import { styled } from 'buttered';

export let Description = styled('div')`
  font-size: 1.1em;
  font-weight: 500;
`;
